// extracted by mini-css-extract-plugin
module.exports = {"iconWrap":"ActivityIcon_iconWrap__MNyGV","badge":"ActivityIcon_badge__B1tvx"};